/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSurveyCommandDto,
  OperationResponse,
  SurveyDetailsResponseDto,
  SurveyListResponseDto,
  SurveyQuestionsResponse,
  UpdateSurveyCommandDto,
} from '../models/index';
import {
    CreateSurveyCommandDtoFromJSON,
    CreateSurveyCommandDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SurveyDetailsResponseDtoFromJSON,
    SurveyDetailsResponseDtoToJSON,
    SurveyListResponseDtoFromJSON,
    SurveyListResponseDtoToJSON,
    SurveyQuestionsResponseFromJSON,
    SurveyQuestionsResponseToJSON,
    UpdateSurveyCommandDtoFromJSON,
    UpdateSurveyCommandDtoToJSON,
} from '../models/index';

export interface CreateQuestionnaireRequest {
    createSurveyCommandDto: CreateSurveyCommandDto;
}

export interface DeleteSurveyRequest {
    id: string;
}

export interface GetSurveyRequest {
    id: string;
    includeQuestions?: boolean;
}

export interface GetSurveyQuestionsRequest {
    id: string;
}

export interface GetSurveysRequest {
    branchId?: string;
    contextId?: string;
    activeOnly?: boolean;
}

export interface UpdateSurveyRequest {
    id: string;
    updateSurveyCommandDto: UpdateSurveyCommandDto;
}

/**
 * 
 */
export class SurveyApi extends runtime.BaseAPI {

    /**
     * Create a new questionnaire
     */
    async createQuestionnaireRaw(requestParameters: CreateQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createSurveyCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createSurveyCommandDto',
                'Required parameter "createSurveyCommandDto" was null or undefined when calling createQuestionnaire().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questionnaires`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSurveyCommandDtoToJSON(requestParameters['createSurveyCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a new questionnaire
     */
    async createQuestionnaire(requestParameters: CreateQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createQuestionnaireRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a survey
     */
    async deleteSurveyRaw(requestParameters: DeleteSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSurvey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questionnaires/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a survey
     */
    async deleteSurvey(requestParameters: DeleteSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteSurveyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get survey details by ID
     */
    async getSurveyRaw(requestParameters: GetSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SurveyDetailsResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSurvey().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeQuestions'] != null) {
            queryParameters['includeQuestions'] = requestParameters['includeQuestions'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questionnaires/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SurveyDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get survey details by ID
     */
    async getSurvey(requestParameters: GetSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SurveyDetailsResponseDto> {
        const response = await this.getSurveyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get questions for a specific survey
     */
    async getSurveyQuestionsRaw(requestParameters: GetSurveyQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SurveyQuestionsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSurveyQuestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questionnaires/{id}/questions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SurveyQuestionsResponseFromJSON(jsonValue));
    }

    /**
     * Get questions for a specific survey
     */
    async getSurveyQuestions(requestParameters: GetSurveyQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SurveyQuestionsResponse> {
        const response = await this.getSurveyQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of questionnaires
     */
    async getSurveysRaw(requestParameters: GetSurveysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SurveyListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['branchId'] != null) {
            queryParameters['branchId'] = requestParameters['branchId'];
        }

        if (requestParameters['contextId'] != null) {
            queryParameters['contextId'] = requestParameters['contextId'];
        }

        if (requestParameters['activeOnly'] != null) {
            queryParameters['activeOnly'] = requestParameters['activeOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/questionnaires`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SurveyListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get list of questionnaires
     */
    async getSurveys(requestParameters: GetSurveysRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SurveyListResponseDto> {
        const response = await this.getSurveysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing survey
     */
    async updateSurveyRaw(requestParameters: UpdateSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSurvey().'
            );
        }

        if (requestParameters['updateSurveyCommandDto'] == null) {
            throw new runtime.RequiredError(
                'updateSurveyCommandDto',
                'Required parameter "updateSurveyCommandDto" was null or undefined when calling updateSurvey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/questionnaires/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSurveyCommandDtoToJSON(requestParameters['updateSurveyCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing survey
     */
    async updateSurvey(requestParameters: UpdateSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateSurveyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
